import { getQrIntercom } from '../../api/qr/qrIntercom';
import { QR_ENTRANCE_STATUS } from '../../constants/qr';

export const SET_ENTRANCE_ID = 'SET_ENTRANCE_ID';
export const SET_ENTRANCE_STATUS = 'SET_ENTRANCE_STATUS';
export const SET_VERIFIED_ENTRANCE = 'SET_VERIFIED_ENTRANCE';
export const SET_SELECTED_RESIDENT = 'SET_SELECTED_RESIDENT';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_NOTICE = 'SET_NOTICE';
export const RESET = 'RESET';

let loadSeq = 0;

const setEntranceId = ({ commit }, payload) => {
    commit(SET_ENTRANCE_ID, payload);
};

const setVerifiedEntrance = ({ commit }, payload) => {
    commit(SET_VERIFIED_ENTRANCE, payload);
};

const selectResident = ({ commit }, payload) => {
    commit(SET_SELECTED_RESIDENT, payload);
};

const setSearchQuery = ({ commit }, payload) => {
    commit(SET_SEARCH_QUERY, payload);
};

const showNotice = ({ commit }, payload) => {
    commit(SET_NOTICE, payload);
};

const clearNotice = ({ commit }) => {
    commit(SET_NOTICE, null);
};

const reset = ({ commit }) => {
    commit(RESET);
};

const loadEntrance = async ({ commit, state }, publicId) => {
    if (!publicId) return;
    if (publicId !== state.entranceId) {
        commit(RESET);
        commit(SET_ENTRANCE_ID, publicId);
    }
    const seq = ++loadSeq;
    commit(SET_ENTRANCE_STATUS, QR_ENTRANCE_STATUS.LOADING);
    try {
        const intercom = await getQrIntercom(publicId);
        if (seq !== loadSeq) return;
        commit(SET_VERIFIED_ENTRANCE, intercom);
    } catch {
        if (seq !== loadSeq) return;
        commit(SET_ENTRANCE_STATUS, QR_ENTRANCE_STATUS.ERROR);
    }
};

export default {
    setEntranceId,
    setVerifiedEntrance,
    selectResident,
    setSearchQuery,
    showNotice,
    clearNotice,
    reset,
    loadEntrance,
};
